var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.show}},[(_vm.hidden)?_c('span',[_vm._v("\n          ********** (hidden - click to reveal)\n      ")]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }